import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./ValidateAccount.scss";

function ValidateAccount(props) {
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            toast.error("Token manquant");
            navigate("/");
            return;
        }

        axios.get(`${process.env.REACT_APP_BASE_URL_USPN_API}/validate-account/${token}`, {} , {
            headers: props.auth.token
                ? {
                    accept: "application/json",
                    Authorization: `Bearer ${props.auth.token}`,
                }
                : {
                    accept: "application/json",
                },
        })
            .then((response) => {

                if (response.status === 401) {
                    toast.error("L'utilisateur n'est pas un ancien élève", {className: "custom-toast--error"});
                } else {
                    toast.success("Votre compte a bien été validé !");
                }

                setTimeout(() => navigate("/"), 3000);

                window.location.reload();
            })
            .catch(error => {
                const message =
                    error.response?.data?.error ||
                    error.message ||
                    "Erreur inattendue";
                toast.error(message, {className: "custom-toast--error"});
                setTimeout(() => navigate("/"), 3000);
            })
            .finally(() => {
            });

    }, [token, navigate]);

    return (
        <div className="flex justify-center items-center h-screen">
            <p className="text-xl text-xl-center">Validation de votre compte en cours...</p>
        </div>
    );
}

ValidateAccount.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(ValidateAccount);